import { FC, Children } from "react"
import classNames from "classnames"

const InfoDropdownList: FC<React.PropsWithChildren<{}>> = ({
    children,
}) => {
    const isMulti = !!Children.count(children)
    return (
        <div className={classNames("text-left py-1 h-100", isMulti && "overflow-y-auto")}>
            {children}
        </div>
    )
}

export default InfoDropdownList
